/* eslint-disable no-param-reassign */
import moment from 'moment';
import { validateCpf, validateCartaoSus, validatePis } from './validateDocuments';
import { validaNome } from './validateName';
import regexps from './regexps';

function hasInitialOrFinalSpaces(string) {
    return /(^\s)|(\s$)/.test(string);
}

function validateName(form, key) {
    const resultValidaNome = validaNome(form[key].value);

    if (resultValidaNome.length > 0) {
        const [resultName] = resultValidaNome;

        form[key].error = resultName;
    }

    if (hasInitialOrFinalSpaces(form[key].value)) {
        form[key].error = 'Remova o espaço em branco no começo ou final do campo';
    }
}

const validators = {
    admissionDate(form) {
        if (
            !!form.dateStartPlan &&
            !!form.dateStartPlan.value &&
            moment(form.admissionDate.value) > moment(form.dateStartPlan.value)
        ) {
            form.admissionDate.error = 'Data superior à data de inclusão no plano';
        }

        if (!!form.birth && !!form.birth.value && moment(form.admissionDate.value) < moment(form.birth.value)) {
            form.admissionDate.error = 'Data anterior à data de nascimento';
        }
    },

    birth(form) {
        if (
            !!form.dateStartPlan &&
            !!form.dateStartPlan.value &&
            moment(form.birth.value) > moment(form.dateStartPlan.value)
        ) {
            form.birth.error = 'Data superior à data de inclusão no plano';
        }

        if (moment().diff(form.birth.value, 'years') >= 130) {
            form.birth.error = 'Idade até 130 anos para o beneficiário';
        }

        if (moment(form.birth.value) > moment()) {
            form.birth.error = 'Data posterior à data de hoje';
        }

        if (form.admissionDate && form.admissionDate.value) {
            form.admissionDate.error = false;
            this.admissionDate(form);
        }

        if (form.dn && form.cpf) {
            form.dn.disabled = !(form.birth.value && moment(form.birth.value).year() >= 2010);
        }
    },

    cellphone(form) {
        if (form.cellphone.required && !regexps.cellphone.test(form.cellphone.value)) {
            form.cellphone.error = 'Digite um telefone com o DDD válido';
        }
    },

    civilState(form) {
        if (form.weddingDate) {
            form.weddingDate.error = '';

            if (form.civilState.value === '2' || form.civilState.value === '9') {
                form.weddingDate.required = true;
            } else {
                form.weddingDate.required = false;
            }
        }
    },

    cpf(form) {
        if (form.cpf.required && (!regexps.cpf.test(form.cpf.value) || !validateCpf(form.cpf.unmaskedValue))) {
            form.cpf.error = 'Digite um número de CPF válido';
        }

        if (form.dn && form.birth) {
            form.dn.disabled = !(form.birth.value && moment(form.birth.value).year() >= 2010);
        }

        if (form.dn) {
            form.dn.required = !form.cpf?.value;
            form.dn.error = '';
        }
    },

    cnpj(form) {
        if (!!form.cnpj.value && !regexps.cnpj.test(form.cnpj.value)) {
            form.cnpj.error = form.cnpj.requiredMessage;
        }
    },

    dateStartPlan(form) {
        // Data inicio do plano n pode ser maior do que data nascimento
        if (!!form.birth && !!form.birth.value && moment(form.dateStartPlan.value) < moment(form.birth.value)) {
            form.dateStartPlan.error = 'Data inferior à data de nascimento do beneficiário';
        }

        if (!!form.dateStartPlan.value && moment(form.dateStartPlan.value).year() < 1968) {
            form.dateStartPlan.error = 'Data inferior ao ano de 1968';
        }

        if (moment(form.dateStartPlan.value) < moment('01/01/1940', 'DD/MM/YYYY')) {
            form.dateStartPlan.error = 'Data inferior ao ano de 1940';
        }

        if (form.dateStartPlan.isValidDate === false) {
            form.dateStartPlan.error = 'Insira uma data válida';
        }

        if (form.dateStartPlan.value && moment(form.dateStartPlan.value).isBefore(moment(), 'day')) {
            form.dateStartPlan.error = 'Data não pode ser retroativa';
        }
    },

    // Tela de aposentados e demitidos
    demissionDate(form) {
        const formattedDate = moment(form.demissionDate.value);

        if (form.dtInclusao && formattedDate <= moment(form.dtInclusao, 'MM/DD/YYYY HH:mm:ss')) {
            form.demissionDate.error = 'Data informada não pode ser anterior ou igual a data de inclusão.';
        }

        if (form.dtNascimento && formattedDate <= moment(form.dtNascimento, 'MM/DD/YYYY HH:mm:ss')) {
            form.demissionDate.error = 'Data não pode ser menor do que a data de nascimento.';
        }
    },

    // Tela de desligar beneficiários
    dismissalDate(form) {
        // Format para remover o horario da comparacao, e comparar apenas data: dia mes ano
        if (
            !!form.dismissalDate.value &&
            moment(form.dismissalDate.value).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')
        ) {
            form.dismissalDate.error = 'Data escolhida não pode ser uma data anterior ao dia corrente';
        }

        if (!!form.dismissalDate.value && !!form.dataFimVigencia) {
            if (form.dataFimVigencia && moment(form.dismissalDate.value) > moment(form.dataFimVigencia, 'DD/MM/YYYY')) {
                form.dismissalDate.error = 'Data escolhida não pode ser posterior a vigência do contrato.';
            }
        }
    },

    dn(form) {
        if (!!form.dn.value && !regexps.dn.test(form.dn.value)) {
            form.dn.error = form.dn.requiredMessage;
        }

        if (!!form.dn.value && form.dn.value.length !== 11) {
            form.dn.error = 'Adicione numeração de 11 dígitos';
        }
    },

    dueDate(form) {
        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (form.dueDate.value < 1 || form.dueDate.value > 31 || form.dueDate.value === 'e') {
            form.dueDate.error = 'Data informada não pode ser inferior a 1 nem superior a 31.';
        }
    },

    email(form) {
        if (!regexps.email.test(form.email.value)) {
            form.email.error = 'Digite um e-mail válido';
        }
    },

    fullName(form) {
        validateName(form, 'fullName');
    },

    height(form) {
        if (form.height.value < 1 || form.height.value > 2.5) {
            form.height.error = 'Altura inválida';
        }
    },

    motherName(form) {
        validateName(form, 'motherName');
    },

    pis(form) {
        if (!!form.pis && !!form.pis.value && !validatePis(form.pis.value)) {
            form.pis.error = 'Número do PIS inválido';
        }

        if (!!form.pis && !!form.pis.value && !regexps.pis.test(form.pis.value)) {
            form.pis.error = 'Adicione numeração de 11 dígitos';
        }
    },

    socialName(form) {
        validateName(form, 'socialName');

        if (form.socialName?.value && form.socialName.value.length > 30) {
            form.socialName.error =
                'Limite de 30 caracteres excedido, necessário abreviação, deve ser preservado o primeiro nome e o ultimo sobrenome.';
        }
    },

    sus(form) {
        if (!!form.sus && !!form.sus.value && !validateCartaoSus(form.sus.value)) {
            form.sus.error = 'Número do SUS inválido';
        }

        if (!!form.sus && !!form.sus.value && !regexps.sus.test(form.sus.value)) {
            form.sus.error = 'Adicione numeração de 15 dígitos';
        }
    },

    contributionDays(form) {
        if (
            form.contributionDays.value < 0 ||
            form.contributionDays.value > 31 ||
            form.contributionDays.value === 'e'
        ) {
            form.contributionDays.error = 'Data informada não pode ser inferior a 0 nem superior a 31.';
        }
    },

    contributionMonths(form) {
        if (
            form.contributionMonths.value < 0 ||
            form.contributionMonths.value > 12 ||
            form.contributionMonths.value === 'e'
        ) {
            form.contributionMonths.error = 'Data informada não pode ser inferior a 0 nem superior a 12.';
        }
    },

    // Regra de grau de parentesco com data de casamento necessario aprovacao GNDI
    // kinshipDegree(form) {
    //     const list = ['ESPOSA', 'MARIDO', 'COMPANHEIRO', 'COMPANHEIRA'];

    //     if (form.weddingDate) {
    //         form.weddingDate.error = '';
    //         form.weddingDate.disabled = !list.includes(form.kinshipDegree.lookup);
    //     }
    // },

    weddingDate(form) {
        if (!!form.weddingDate && !!form.weddingDate.value && form.weddingDate.value < form.birth.value) {
            form.weddingDate.error = 'Data anterior à data de nascimento';
        }

        if (
            !!form.weddingDate &&
            !!form.weddingDate.value &&
            !!form.birth &&
            !!form.birth.value &&
            moment(form.weddingDate.value) < moment(form.birth.value)
        ) {
            form.weddingDate.error = 'Data inferior à data de nascimento';
        }

        if (!!form.weddingDate && !!form.weddingDate.value && moment(form.weddingDate.value) > moment()) {
            form.weddingDate.error = 'Data posterior à data de hoje';
        }

        // if (moment(form.weddingDate.value) > moment(form.admissionDate))
    },
};

export default validators;
